// @ts-nocheck
import * as constants from './constants';

export const createActionName = (eventName: string) => {
	return `${constants.MODEL_NAME}-action/${eventName}`;
};
